// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { categoryCardStyles } from "@synd/App/Components/Category/CategoryCard";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

categoryCardStyles.categoryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
        max-width: 100%;
    `,
};

categoryCardStyles.imageWrapper = {
    css: css`
        aspect-ratio: 1;
        width: 100%;
    `,
};

categoryCardStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        aspect-ratio: 1;
        border-radius: 50%;
        overflow: hidden;
        align-items: unset;
        img {
            height: 100%;
            object-fit: cover;
        }
    `,
};

categoryCardStyles.title = {
    color: "text",
    css: css`
        ${({ boldTitle }: any) =>
            boldTitle &&
            css`
                ${TypographyStyle} {
                    font-weight: ${fontConfig.weight.bold};
                }
            `}
    `,
    typographyProps: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            margin-bottom: 0;
            text-align: center;
        `,
    },
};
